import React, { useState, useEffect } from 'react';
import { listarFeedbacks, criarFeedback } from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Card, CardContent } from '../components/ui/card';
import { Star } from 'lucide-react';
import { toast } from 'sonner';

const Feedbacks = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    rating: 5,
    comentario: ''
  });

  useEffect(() => {
    carregarFeedbacks();
  }, []);

  const carregarFeedbacks = async () => {
    try {
      const data = await listarFeedbacks(true);
      setFeedbacks(data);
    } catch (error) {
      console.error('Erro ao carregar feedbacks:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nome || !formData.comentario) {
      toast.error('Preencha os campos obrigatórios');
      return;
    }

    try {
      await criarFeedback(formData);
      toast.success('Obrigado pelo seu feedback! Será publicado após aprovação.');
      setFormData({ nome: '', email: '', rating: 5, comentario: '' });
    } catch (error) {
      toast.error('Erro ao enviar feedback');
      console.error(error);
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={20}
        className={i < rating ? 'star-filled' : 'star-empty'}
        fill={i < rating ? 'currentColor' : 'none'}
      />
    ));
  };

  return (
    <div className="feedbacks-page">
      <div className="feedbacks-hero">
        <h1>Feedbacks dos Clientes</h1>
        <p>Veja o que nossos clientes estão dizendo</p>
      </div>

      <div className="container">
        {/* Formulário de Feedback */}
        <section className="feedback-form-section">
          <h2>Deixe Seu Feedback</h2>
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nome">Nome *</label>
                <Input
                  id="nome"
                  value={formData.nome}
                  onChange={(e) => setFormData({...formData, nome: e.target.value})}
                  placeholder="Seu nome"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Avaliação *</label>
              <div className="rating-selector">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    size={32}
                    className={`rating-star ${formData.rating >= star ? 'active' : ''}`}
                    fill={formData.rating >= star ? 'currentColor' : 'none'}
                    onClick={() => setFormData({...formData, rating: star})}
                  />
                ))}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="comentario">Comentário *</label>
              <Textarea
                id="comentario"
                value={formData.comentario}
                onChange={(e) => setFormData({...formData, comentario: e.target.value})}
                placeholder="Conte-nos sobre sua experiência..."
                rows={4}
                required
              />
            </div>

            <Button type="submit" className="submit-btn-feedback">
              Enviar Feedback
            </Button>
          </form>
        </section>

        {/* Lista de Feedbacks */}
        <section className="feedbacks-lista">
          <h2>O Que Dizem Nossos Clientes</h2>
          {loading ? (
            <p>Carregando...</p>
          ) : feedbacks.length === 0 ? (
            <p className="feedbacks-vazio">Ainda não há feedbacks. Seja o primeiro!</p>
          ) : (
            <div className="feedbacks-grid">
              {feedbacks.map((feedback) => (
                <Card key={feedback.id} className="feedback-card">
                  <CardContent className="feedback-content">
                    <div className="feedback-header">
                      <h3>{feedback.nome}</h3>
                      <div className="feedback-stars">
                        {renderStars(feedback.rating)}
                      </div>
                    </div>
                    <p className="feedback-comentario">{feedback.comentario}</p>
                    <span className="feedback-data">
                      {new Date(feedback.criado_em).toLocaleDateString('pt-PT')}
                    </span>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Feedbacks;
